export const ANIMATION_TIMING = 1300;
export const READING_TIMING = 1200;
